import { Route } from "react-router-dom";
import ErrorBoundary from "../components/ErrorComponent/ErrorBoundary";
import { SendIncidencesServiceManagerProvider } from "../Services/Incidences/SendIncidencesServices";
import { OrganizationChartServiceManagerProvider } from "../Services/OrganizationChart/OrganizationCharService";

import { EmployeeMaintenanceServiceManagerProvider } from "../Services/Operations/employeeMaintenance/EmployeeMaintenanceServiceManager";

// Carga diferida de los componentes de las rutas

import { AssistScreen } from "../screens/Assist";
import { RequestsScreen } from "../screens/Collaborators";
import { HomeScreen } from "../screens/Home";
import { InvitationsScreen } from "./../screens/Invitations/index";
import { Logout } from "./../screens/Logout/index";
import { NotFound } from "./../components/NotFound/index";
import { ConfigurationScreen } from "../screens/Configuration";
import { Catalogs } from "../screens/Catalogs";

import { IncidencesScreen } from "../screens/Incidenses";
import { QueriesComponent } from "../screens/Queries";
import { OrganizationChart } from "../screens/OrganizationChart";
import { EmployeeManagement } from "../screens/Operation/EmployeeManagement";
import { JustifyIncidence } from "../screens/justifyIncidence";
import { AccessControlScreen } from "../screens/AccessControl";
import { Balances, LeaveTypes, Policy } from "../screens/Vacations/components";

// Función para memorizar el componente cargado

const routerBrowser = [
  {
    path: "/",
    name: "Home",
    element: <HomeScreen />,
  },
  {
    path: "/applications",
    name: "Applications",
    element: (
      <ErrorBoundary>
        <RequestsScreen />
      </ErrorBoundary>
    ),
  },
  {
    path: "/vacation/balances",
    name: "VacationBalances",
    element: (
      <ErrorBoundary>
        <Balances />
      </ErrorBoundary>
    ),
  },
  {
    path: "/vacation/policies",
    name: "VacationPolicies",
    element: (
      <ErrorBoundary>
        <Policy />
      </ErrorBoundary>
    ),
  },
  {
    path: "/leave-types",
    name: "LeaveTypes",
    element: (
      <ErrorBoundary>
        <LeaveTypes />
      </ErrorBoundary>
    ),
  },
  {
    path: "/assist",
    name: "Assist",
    element: (
      <ErrorBoundary>
        <AssistScreen />
      </ErrorBoundary>
    ),
  },
  {
    path: "/invitations",
    name: "Invitations",
    element: (
      <ErrorBoundary>
        <InvitationsScreen />
      </ErrorBoundary>
    ),
  },
  {
    path: "/centralModuleLogout",
    name: "logout",
    element: <Logout />,
  },
  {
    path: "/catalogs",
    name: "catalogs",
    element: (
      <ErrorBoundary>
        <Catalogs />
      </ErrorBoundary>
    ),
  },
  {
    path: "/configuration",
    name: "configuration",
    element: (
      <ErrorBoundary>
        <ConfigurationScreen />
      </ErrorBoundary>
    ),
  },
  {
    path: "/operation",
    name: "operation",
    element: (
      <ErrorBoundary>
        <EmployeeMaintenanceServiceManagerProvider>
          <EmployeeManagement />
        </EmployeeMaintenanceServiceManagerProvider>
      </ErrorBoundary>
    ),
  },
  {
    path: "/incidences",
    name: "incidences",
    element: (
      <ErrorBoundary>
        <SendIncidencesServiceManagerProvider>
          <IncidencesScreen />
        </SendIncidencesServiceManagerProvider>
      </ErrorBoundary>
    ),
  },
  {
    path: "/queries",
    name: "queries",
    element: (
      <ErrorBoundary>
        <QueriesComponent />
      </ErrorBoundary>
    ),
  },
  {
    path: "/organizationChart",
    name: "organizationChart",
    element: (
      <ErrorBoundary>
        <OrganizationChartServiceManagerProvider>
          <OrganizationChart />
        </OrganizationChartServiceManagerProvider>
      </ErrorBoundary>
    ),
  },
  {
    path: "/accesscontrol",
    name: "AccessControl",
    element: (
      <ErrorBoundary>
        <AccessControlScreen />
      </ErrorBoundary>
    ),
  },
  {
    path: "/justifyIncidence",
    name: "justifyIncidence",
    element: (
      <ErrorBoundary>
        <JustifyIncidence />
      </ErrorBoundary>
    ),
  },
  {
    path: "*",
    name: "NotFound",
    element: <NotFound />,
  },
];

export default routerBrowser.map((route) => {
  return <Route key={route.name} path={route.path} element={route.element} />;
});
